/**
 * Country dial codes for the phone field.
 * Source list is [iso, name, dialCode]; the flag emoji is computed from the ISO
 * code (regional-indicator letters) so there are no image assets and nothing to
 * keep in sync. Israel is pinned first (default); the rest are alphabetical by name.
 */

const isoToFlag = (iso) =>
  String(iso)
    .toUpperCase()
    .replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));

const RAW = [
  // Default
  ["IL", "Israel", "972"],
  // Rest (alphabetical by name)
  ["AF", "Afghanistan", "93"],
  ["AL", "Albania", "355"],
  ["DZ", "Algeria", "213"],
  ["AD", "Andorra", "376"],
  ["AO", "Angola", "244"],
  ["AR", "Argentina", "54"],
  ["AM", "Armenia", "374"],
  ["AU", "Australia", "61"],
  ["AT", "Austria", "43"],
  ["AZ", "Azerbaijan", "994"],
  ["BH", "Bahrain", "973"],
  ["BD", "Bangladesh", "880"],
  ["BY", "Belarus", "375"],
  ["BE", "Belgium", "32"],
  ["BO", "Bolivia", "591"],
  ["BA", "Bosnia and Herzegovina", "387"],
  ["BR", "Brazil", "55"],
  ["BG", "Bulgaria", "359"],
  ["KH", "Cambodia", "855"],
  ["CM", "Cameroon", "237"],
  ["CA", "Canada", "1"],
  ["CL", "Chile", "56"],
  ["CN", "China", "86"],
  ["CO", "Colombia", "57"],
  ["CR", "Costa Rica", "506"],
  ["HR", "Croatia", "385"],
  ["CY", "Cyprus", "357"],
  ["CZ", "Czechia", "420"],
  ["DK", "Denmark", "45"],
  ["DO", "Dominican Republic", "1"],
  ["EC", "Ecuador", "593"],
  ["EG", "Egypt", "20"],
  ["SV", "El Salvador", "503"],
  ["EE", "Estonia", "372"],
  ["ET", "Ethiopia", "251"],
  ["FI", "Finland", "358"],
  ["FR", "France", "33"],
  ["GE", "Georgia", "995"],
  ["DE", "Germany", "49"],
  ["GH", "Ghana", "233"],
  ["GR", "Greece", "30"],
  ["GT", "Guatemala", "502"],
  ["HN", "Honduras", "504"],
  ["HK", "Hong Kong", "852"],
  ["HU", "Hungary", "36"],
  ["IS", "Iceland", "354"],
  ["IN", "India", "91"],
  ["ID", "Indonesia", "62"],
  ["IQ", "Iraq", "964"],
  ["IE", "Ireland", "353"],
  ["IT", "Italy", "39"],
  ["JM", "Jamaica", "1"],
  ["JP", "Japan", "81"],
  ["JO", "Jordan", "962"],
  ["KZ", "Kazakhstan", "7"],
  ["KE", "Kenya", "254"],
  ["KW", "Kuwait", "965"],
  ["LV", "Latvia", "371"],
  ["LB", "Lebanon", "961"],
  ["LT", "Lithuania", "370"],
  ["LU", "Luxembourg", "352"],
  ["MO", "Macau", "853"],
  ["MY", "Malaysia", "60"],
  ["MT", "Malta", "356"],
  ["MX", "Mexico", "52"],
  ["MD", "Moldova", "373"],
  ["MC", "Monaco", "377"],
  ["MA", "Morocco", "212"],
  ["NP", "Nepal", "977"],
  ["NL", "Netherlands", "31"],
  ["NZ", "New Zealand", "64"],
  ["NG", "Nigeria", "234"],
  ["MK", "North Macedonia", "389"],
  ["NO", "Norway", "47"],
  ["OM", "Oman", "968"],
  ["PK", "Pakistan", "92"],
  ["PS", "Palestine", "970"],
  ["PA", "Panama", "507"],
  ["PY", "Paraguay", "595"],
  ["PE", "Peru", "51"],
  ["PH", "Philippines", "63"],
  ["PL", "Poland", "48"],
  ["PT", "Portugal", "351"],
  ["QA", "Qatar", "974"],
  ["RO", "Romania", "40"],
  ["RU", "Russia", "7"],
  ["SA", "Saudi Arabia", "966"],
  ["RS", "Serbia", "381"],
  ["SG", "Singapore", "65"],
  ["SK", "Slovakia", "421"],
  ["SI", "Slovenia", "386"],
  ["ZA", "South Africa", "27"],
  ["KR", "South Korea", "82"],
  ["ES", "Spain", "34"],
  ["LK", "Sri Lanka", "94"],
  ["SE", "Sweden", "46"],
  ["CH", "Switzerland", "41"],
  ["TW", "Taiwan", "886"],
  ["TZ", "Tanzania", "255"],
  ["TH", "Thailand", "66"],
  ["TN", "Tunisia", "216"],
  ["TR", "Turkey", "90"],
  ["UG", "Uganda", "256"],
  ["UA", "Ukraine", "380"],
  ["AE", "United Arab Emirates", "971"],
  ["GB", "United Kingdom", "44"],
  ["US", "United States", "1"],
  ["UY", "Uruguay", "598"],
  ["UZ", "Uzbekistan", "998"],
  ["VE", "Venezuela", "58"],
  ["VN", "Vietnam", "84"],
  ["YE", "Yemen", "967"],
  ["ZM", "Zambia", "260"],
  ["ZW", "Zimbabwe", "263"],
];

export const DEFAULT_COUNTRY_ISO = "IL";

export const COUNTRY_CODES = RAW.map(([iso, name, dialCode]) => ({
  iso,
  name,
  dialCode,
  flag: isoToFlag(iso),
}));
